import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js/instance/every";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import React, { Component } from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import { CheckedProvider } from "../Context.js";
const isSet = val => {
  if (!val) return false;
  const methods = ['has', 'add', 'delete'];
  return _everyInstanceProperty(methods).call(methods, m => typeof val[m] === 'function');
};
class MultiSelectGroup extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleValuesChange", evt => {
      const {
        value
      } = evt.target;
      const {
        values,
        onValuesChange,
        onChange
      } = this.props;
      let newValues;
      if (isSet(values)) {
        newValues = new _Set(values);
        if (values.has(value)) {
          newValues.delete(value);
        } else {
          newValues.add(value);
        }
      } else if (_Array$isArray(values)) {
        if (_includesInstanceProperty(values).call(values, value)) {
          newValues = _filterInstanceProperty(values).call(values, v => v !== value);
        } else {
          newValues = [...values, value];
        }
      } else {
        throw new Error('Expected a Set or an Array object as `values`');
      }
      onChange(evt);
      onValuesChange(newValues, evt);
    });
  }
  childIsChecked(childProps) {
    const {
      values
    } = this.props;
    if (isSet(values)) {
      return values.has(childProps.value);
    }
    if (_Array$isArray(values)) {
      return _includesInstanceProperty(values).call(values, childProps.value);
    }
    throw new Error('Expected a Set or an Array object as `values`');
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(CheckedProvider, {
      value: {
        onChange: this.handleValuesChange,
        isChecked: value => this.childIsChecked({
          value
        })
      }
    }, children);
  }
}
_defineProperty(MultiSelectGroup, "defaultProps", {
  onChange: noop,
  onValuesChange: noop
});
process.env.NODE_ENV !== "production" ? MultiSelectGroup.propTypes = {
  /**
   * One to many Checkbox components.
   */
  children: PropTypes.node,
  /**
   * The currently selected values.
   */
  values: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.shape({
    has: PropTypes.func
  })]),
  /**
   * Callback for when user selects a value. Prefer to use `onValuesChange`
   *
   * ```ts
   * type onChange = (evt: React.SyntheticEvent): void
   * ```
   */
  onChange: PropTypes.func,
  /**
   * Callback called when user selects a value. The `values` argument is the new set of values selected. Its type depends on the type given via the `values` prop.
   *
   * ```ts
   * type onValuesChange = (value: Set<string> | string[], evt: React.SyntheticEvent): void
   * ```
   */
  onValuesChange: PropTypes.func
} : void 0;
export default MultiSelectGroup;